import Vue from 'vue';
import axios from 'axios';
import Buefy from 'buefy';
import lodash from 'lodash';
import VueRouter from 'vue-router';
import VueYoutube from 'vue-youtube';
import Vue2Crumbs from 'vue-2-crumbs';
import VueFullscreen from 'vue-fullscreen';
import VueVideoPlayer from 'vue-video-player';

import 'video.js/dist/video-js.css';

window._ = lodash;

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = axios;

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

window.axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      location.reload();
    }
    return Promise.reject(error)
  },
)

window.Vue = Vue;

Vue.use(Buefy, {
    defaultIconPack: 'fa',
});

Vue.use(VueRouter);

Vue.use(VueYoutube);

Vue.use(VueVideoPlayer);

Vue.use(Vue2Crumbs);

Vue.use(VueFullscreen);